import { createSlice } from '@reduxjs/toolkit'
import { retrieveCustomerAdminRoles, retrieveSystemAdminRoles, searchRoles } from './rolesThunk'

const defaultActiveSort = 'LAST_ADDED'

const initialState = {
  pageNumber: 0,
  summaries: {},
  sortBy: ['LAST_ADDED', 'LAST_UPDATED', 'NAME', 'Name_TRANSLATED'],
  activeSort: defaultActiveSort,
  value: [],
  loading: false,
}

const rolesSlice = createSlice({
  name: 'roles',
  initialState,

  extraReducers: {
    [retrieveSystemAdminRoles.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [retrieveSystemAdminRoles.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.value = payload
    },
    [retrieveCustomerAdminRoles.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [retrieveCustomerAdminRoles.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.value = payload
    },
    [searchRoles.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [searchRoles.fulfilled]: (state, { payload }) => {
      state.value = payload.data.data
      state.loading = false
    },
  },
})

export const selectRoles = ({ roles }) => roles
export const { activeSummaryHandler } = rolesSlice.actions

export default rolesSlice.reducer
